
import {Component, Vue, Watch} from "vue-property-decorator";
import {formRules} from "@/utils/formRules";
import CompareCoordinatesModal from "./CompareCoordinatesModal.vue";

@Component({
  components: {CompareCoordinatesModal},
})
export default class PreviewBuildings extends Vue {

  private currentBuildings: any = [];
  private headers: object[] = [];
  private search: string = "";
  private loading: boolean = false;
  private saving: boolean = false;
  private rules: object = formRules;
  private valid: boolean = true;
  private displayCoordsConflict: boolean = false;
  private selectedItem: any = null;

  private mounted() {
    this.headers = [
      {value: "informations", sortable: false},
      {value: "name", text: this.$t("Buildings.name"), sortable: true},
      {value: "address", text: this.$t("Buildings.address"), sortable: true},
      {value: "zipcode", text: this.$t("Buildings.zipcode"), sortable: true},
      {value: "city", text: this.$t("Buildings.city"), sortable: true},
      {value: "registrationNumber", text: this.$t("Buildings.registrationNumber"), sortable: true},
      {value: "latitude", text: this.$t("form.latitude"), sortable: false},
      {value: "longitude", text: this.$t("form.longitude"), sortable: false},
    ];
    this.reset();
    if (!this.currentBuildings || (this.currentBuildings && this.currentBuildings.length) === 0) {
      this.$router.push({name: "buildings"});
    }
  }

private reset(): void {
  this.currentBuildings = JSON.parse(JSON.stringify(this.$route.params.items));

  this.currentBuildings.sort((a, b) => {
    const aError =
      a.databaseDuplicate ||
      a.currentValues?.conflict;

    const bError =
      b.databaseDuplicate ||
      b.currentValues?.conflict;

    if (aError && !bError) { return -1; }
    if (!aError && bError) { return 1; }

    return 0;
  });
}

  private openConflict(item: any): void {
    this.selectedItem = item;
    this.displayCoordsConflict = true;
  }

  get isSaveDisabled(): boolean {
    if (!this.valid) { return true; }

    return this.currentBuildings.some((b) =>
        b.databaseDuplicate ||
        b.currentValues.conflict,
    );
    }

    private handleCoordinatesValidate(result) {
    if (!this.selectedItem) { return; }

    Object.assign(this.selectedItem.currentValues, result);
    this.selectedItem.currentValues.conflict = false;
    }

  // Reset one building property to the import value
  // If no property is specified, reset all building's properties to the import values
  private resetBuildingProperty(building: any, property?: string): void {
    if (property) {
      building.currentValues[property] = building.importValues[property];
      building.duplicate = false;
    } else {
      Object.keys(building.currentValues).forEach((prop) => {
        building.currentValues[prop] = building.importValues[prop];
        building.duplicate  = false;
      });
    }
  }

  // Called when the user edit a building's name inline : check for duplicates name in the import
  private checkDuplicates(building: any) {
      const usedBuildingName = this.currentBuildings.map((building) => building.currentValues.name);
      const firstIndex = usedBuildingName.indexOf(building.currentValues.name);
      const lastIndex = usedBuildingName.lastIndexOf(building.currentValues.name);
      building.duplicate = firstIndex !== lastIndex;
      if (building.importValues.name !== building.currentValues.name && !!building.databaseDuplicateImport) {
        building.databaseDuplicate = false;
      } else if (building.importValues.name === building.currentValues.name && !!building.databaseDuplicateImport) {
        building.databaseDuplicate = true;
      }
  }

private searchCurrentValues(value: any, search: string, item: any): boolean {
  const lowerSearch = search.toLowerCase();
  return Object.values(item.currentValues).some((val: any) => {
    if (val === null || val === undefined) {
      return false;
    }
    return String(val)
      .toLowerCase()
      .includes(lowerSearch);
  });
}

  private getChipColor(item: any, property: string): string {
    if (item.databaseDuplicate || item.currentValues.conflict) {
      return "red";
    } else if (item.duplicate) {
      return "grey";
    } else if (item.currentValues[property] !== item.importValues[property]) {
      return "warning";
    } else {
      return "default";
    }
  }

  private getChipTextColor(item: any, property: string): string {
    if (item.databaseDuplicate || item.currentValues.conflict) {
      return "red";
    } else if (item.duplicate) {
      return "grey";
    } else if (item.currentValues[property] !== item.importValues[property]) {
      return "warning";
    } else {
      return "default";
    }
  }

  private deleteBuilding(building): void {
    if (confirm(this.$t("Buildings.deleteConfirmation").toString())) {
      const pos = this.currentBuildings.map((u) => u.importId).indexOf(building.importId);
      this.currentBuildings.splice(pos, 1);
    }
  }

  private importBuildings(): void {
    this.saving = true;
    this.$store.dispatch("buildings/importBuildings", {
      buildings: this.currentBuildings,
      companyId: this.$route.params.companyId,
    })
      .then((data) => {
        this.$store.commit("alerts/displaySuccess", {
                msg: this.$t("Buildings.successImport"),
        });
        this.$router.push({name: this.$route.params.importType, params: {data}});
      })
      .catch((err) => {
        const error: string = err.response?.data?.message;
        const splitError: string[] = error.split("--");
        this.$store.commit("alerts/displayError", {
            msg: this.$t("Buildings." + `${splitError[0]}`, {
                        building : splitError[1],
                    }),
        });
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
